import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'comp-price-cost',
  templateUrl: 'price-cost.html',
})
export class PriceCostPage {
  @Input() type;
  @Input() sub_recipe;
  @Input() price;
  @Input() foodcost;
  @Input() menu_cost;
  @Input() parts;
  @Input() weight;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/components/price-cost/price-cost.ts